import { RefObject, useCallback } from 'react'

export const useAutoHeightTextarea = (textareaRef: RefObject<HTMLTextAreaElement>) =>
  useCallback(() => {
    if (!textareaRef.current) return

    textareaRef.current.style.setProperty('height', '0px')
    textareaRef.current.style.setProperty('height', `${textareaRef.current.scrollHeight}px`)
  }, [textareaRef])
